import { render, staticRenderFns } from "./VModalImageViewer.vue?vue&type=template&id=fa430324&"
import script from "./VModalImageViewer.vue?vue&type=script&lang=ts&"
export * from "./VModalImageViewer.vue?vue&type=script&lang=ts&"
import style0 from "./VModalImageViewer.vue?vue&type=style&index=0&id=fa430324&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports